import React, { Component } from "react";
import { Translate } from "react-redux-i18n";

export default class WirelessPlanMessage extends Component {
    render() {
        return <div className="container wireless-plan-message" style={{ display: "none" }}>
            <div className="row">
                <div className="col-md-12">
                    <div className="boxed bg--secondary boxed--lg boxed--border">
                        <p>
                            <Translate value="dataPlans.message" />
                        </p>
                    </div>
                </div>
            </div>
        </div>;
    }
}